export default __webpack_public_path__ + "static/1.2_DE-d7a298b3f4daf46b059bf65871291851.webp";